import {
  Badge, Spacer, Table, Text, Tooltip,
} from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import translations from 'client/internationalization/translation-map.json';
import { sumBy } from 'es-toolkit';
import { TDefaultResultTableProps } from 'common/interfaces/query';
import { filterDefaultQueryResult, getResultEntityPath } from '../query-utils';

export const DefaultResultTable = ({
  archiveId, queryResult, resultConfig, setFilters,
}: TDefaultResultTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyId } = useParams();

  const { data = [] } = queryResult;
  const { hierarchy = [], filters = {} } = resultConfig || {};

  const hierarchyHeaderCells = resultConfig?.hierarchy?.map((hierarchyItem) => ({
    value: t(hierarchyItem),
  })) || [];

  const filteredData = filterDefaultQueryResult(data, filters);
  const rows = filteredData?.flatMap((result) => {
    const { name, objects: designs } = result;
    const groupRow = {
      value: (
        <>
          <Text>
            {name}
          </Text>
          <Spacer width="var(--padding-xxs)" />
          <Tooltip text="Items per group"><Badge color="var(--color-neutral-400)" title={designs.length} /></Tooltip>
        </>
      ),
      rowSpan: designs.length,
    };

    return designs.map((desigHierarchyData, index) => {
      const path = getResultEntityPath(companyId, archiveId, desigHierarchyData.design.id);
      const designCell = {
        value: (
          <Text link onClick={() => navigate(path)}>
            {desigHierarchyData.design.name}
          </Text>
        ),
        ...(index > 0 && {
          style: { borderLeft: 'solid var(--color-border) 1px' },
        }),
      };
      const hierarchyDataCells = hierarchy?.map((hierarchyItem) => ({
        value: desigHierarchyData[hierarchyItem]?.name,
        style: { borderLeft: 'solid var(--color-border) 1px' },
      })) || [];
      const cells = index === 0 ? [groupRow, ...hierarchyDataCells, designCell] : [...hierarchyDataCells, designCell];
      return { cells };
    });
  }) ?? [];
  const dataFilterCells = [filteredData[0]?.entityType, ...hierarchy, 'design']?.map((key) => {
    const filterValue = filters?.[key] || '';
    return {
      key,
      value: filterValue,
      type: 'Input',
      placeholder: 'Filter',
      onChange: (ev: any) => setFilters({
        [key]: ev.target.value,
      }),
    };
  });

  const table = {
    headers: [
      {
        cells: [
          {
            value:
  <>
    <Text>{t(`${filteredData?.[0]?.entityType ?? ''}`)}</Text>
    <Spacer width="var(--padding-xxs)" />
    <Tooltip text="Total Groups"><Badge color="var(--color-neutral-400)" title={filteredData.length} /></Tooltip>
    <Spacer width="var(--padding-xxs)" />
    <Tooltip text="Total Items"><Badge color="var(--color-neutral-400)" title={sumBy(filteredData, (obj) => obj.objects.length)} /></Tooltip>
  </>,
          },
          ...hierarchyHeaderCells,
          { value: t(translations.design) },
        ],
      },
      {
        cells: dataFilterCells,
      },
    ],
    rows,
  };
  return (
    <Table table={table} />
  );
};